/* altE v2.2: header menus, mobile drawer, product page enhancements. Cart and search use Dawn's scripts. */
(() => {
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const hoverable = window.matchMedia('(hover: hover) and (min-width: 990px)');
  const pops = $$('[data-av-pop]');
  const drawers = $$('[data-av-drawer]');

  const closePops = (keep) => pops.forEach((d) => { if (d !== keep) d.open = false; });

  pops.forEach((d) => {
    const item = d.parentElement;
    const summary = d.querySelector('summary');
    let timer;
    d.addEventListener('toggle', () => { if (d.open) closePops(d); });
    item.addEventListener('mouseenter', () => {
      if (!hoverable.matches) return;
      clearTimeout(timer);
      timer = setTimeout(() => { if (!d.open) { d.dataset.hover = '1'; d.open = true; } }, 90);
    });
    item.addEventListener('mouseleave', () => {
      if (!hoverable.matches) return;
      clearTimeout(timer);
      timer = setTimeout(() => { d.open = false; d.dataset.hover = ''; }, 180);
    });
    summary.addEventListener('click', (e) => {
      if (d.dataset.hover === '1') { e.preventDefault(); d.dataset.hover = ''; }
    });
  });

  drawers.forEach((d) => {
    d.addEventListener('toggle', () => document.documentElement.classList.toggle('av-lock', d.open));
    $$('[data-av-close]', d).forEach((b) => b.addEventListener('click', () => {
      d.open = false;
      d.querySelector('summary').focus();
    }));
  });

  document.addEventListener('click', (e) => {
    pops.forEach((d) => { if (d.open && !d.contains(e.target)) d.open = false; });
    drawers.forEach((d) => {
      const panel = d.querySelector('.av-drawer__panel');
      if (d.open && !panel.contains(e.target) && !d.querySelector('summary').contains(e.target)) d.open = false;
    });
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    pops.concat(drawers).forEach((d) => {
      if (!d.open) return;
      d.open = false;
      d.querySelector('summary').focus();
    });
  });

  /* Wide tables in altE's content scroll inside their own box instead of widening the page */
  $$('.rte table').forEach((t) => {
    if (t.parentElement.classList.contains('av-table')) return;
    const box = document.createElement('div');
    box.className = 'av-table';
    t.before(box);
    box.append(t);
  });

  /* Written contact and quote forms: prefill topic and item from the link (?topic=quote&item=...) */
  const contact = document.querySelector('[data-av-contact]');
  if (contact && !contact.querySelector('.av-contact__done')) {
    const q = new URLSearchParams(window.location.search);
    const item = contact.querySelector('[data-av-item]');
    const topic = contact.querySelector('[data-av-topic]');
    if (item && q.get('item') && !item.value) item.value = q.get('item').slice(0, 200);
    if (topic && q.get('topic') === 'quote') topic.value = 'Quote request';
    /* After a validation error Shopify returns the visitor to this page with what they typed in the address, but the form only refills the email and message itself. Restore the other fields. */
    if (contact.querySelector('.av-contact__error')) {
      contact.querySelectorAll("input[name^='contact['], select[name^='contact['], textarea[name^='contact[']").forEach((el) => {
        const saved = el.type !== 'hidden' && !el.value && q.get(el.name);
        if (saved) el.value = saved.slice(0, 2000);
      });
    }
  }

  /* Product page */
  const pdp = document.querySelector('[data-av-pdp]');
  if (!pdp) return;

  const main = pdp.querySelector('[data-av-main]');
  const mainImg = main && main.querySelector('img');
  const thumbs = $$('[data-av-thumb]', pdp);
  const showThumb = (b) => {
    if (!mainImg || !b) return;
    mainImg.removeAttribute('srcset');
    mainImg.src = b.dataset.src;
    mainImg.srcset = b.dataset.srcset;
    main.href = b.dataset.full;
    thumbs.forEach((t) => t.classList.toggle('is-active', t === b));
  };
  thumbs.forEach((b) => b.addEventListener('click', () => showThumb(b)));

  const select = pdp.querySelector('[data-av-variant]');
  const data = pdp.querySelector('[data-av-variants]');
  if (select && data) {
    const variants = JSON.parse(data.textContent);
    const money = new Intl.NumberFormat(pdp.dataset.locale || 'en', {
      style: 'currency',
      currency: pdp.dataset.currency || 'USD',
    });
    const tplOk = pdp.querySelector('[data-av-tpl-ok]');
    const tplStop = pdp.querySelector('[data-av-tpl-stop]');
    select.addEventListener('change', () => {
      const v = variants.find((x) => String(x.id) === select.value);
      if (!v) return;
      $$('[data-av-price]', pdp).forEach((el) => {
        const now = el.querySelector('.av-price__now');
        const was = el.querySelector('.av-price__was');
        if (now) now.textContent = money.format(v.price / 100);
        if (was) {
          was.hidden = !(v.compare_at_price > v.price);
          if (!was.hidden) was.lastChild.textContent = money.format(v.compare_at_price / 100);
        }
      });
      const tpl = v.available ? tplOk : tplStop;
      if (tpl) $$('[data-av-avail]', pdp).forEach((el) => {
        const small = el.classList.contains('av-avail--sm');
        el.outerHTML = tpl.innerHTML.replace('class="av-avail', small ? 'class="av-avail av-avail--sm' : 'class="av-avail');
      });
      const sku = pdp.querySelector('[data-av-sku]');
      if (sku) { sku.hidden = !v.sku; sku.querySelector('span').textContent = v.sku || ''; }
      const skuMini = pdp.querySelector('[data-av-sku-mini]');
      if (skuMini) skuMini.textContent = v.sku || '';
      $$('[data-av-add], [data-av-add-mini], [data-av-add-mobi]', pdp).forEach((b) => {
        b.disabled = !v.available;
        const label = b.querySelector('span') || b;
        label.textContent = v.available ? 'Add to cart' : 'Sold out';
      });
      const quote = pdp.querySelector('[data-av-quote]');
      if (quote) {
        quote.hidden = v.available;
        const ql = quote.querySelector('[data-av-quote-link]');
        if (ql) {
          const u = new URL(ql.href, window.location.origin);
          u.searchParams.set('item', `${pdp.dataset.title} (${v.sku || v.title})`);
          ql.href = u.pathname + u.search;
        }
      }
      if (v.featured_media) showThumb(thumbs.find((t) => t.dataset.mediaId === String(v.featured_media.id)));
      const pickup = pdp.querySelector('pickup-availability');
      if (pickup && typeof pickup.fetchAvailability === 'function') pickup.fetchAvailability(v.id);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    });
  }

  /* altE's product content: tiers, cautions and an "On this page" bar built from its headings */
  const desc = pdp.querySelector('[data-av-desc]');
  const wrapFrom = (h, cls, stop) => {
    const box = document.createElement('div');
    box.className = cls;
    h.before(box);
    let n = h.nextElementSibling;
    box.append(h);
    while (n && !stop.test(n.tagName)) {
      const next = n.nextElementSibling;
      box.append(n);
      n = next;
    }
  };
  if (desc) {
    $$('h4', desc).forEach((h) => {
      const t = h.textContent.toLowerCase();
      const kind = t.includes('usually') ? 'req' : t.includes('may be') ? 'may' : t.includes('optional') ? 'opt' : '';
      if (kind) wrapFrom(h, `av-tier av-tier--${kind}`, /^H[1-4]$/);
    });
    $$('h2, h3', desc).forEach((h) => {
      if (/important|caution|warning/i.test(h.textContent)) wrapFrom(h, 'av-note', /^H[1-3]$/);
    });
    const toc = pdp.querySelector('[data-av-toc]');
    const heads = $$('h2, h3', desc);
    if (toc && heads.length > 1) {
      heads.forEach((h, i) => {
        const text = h.textContent.trim();
        if (!h.id) h.id = `av-${text.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || i}`;
        const li = document.createElement('li');
        const a = document.createElement('a');
        a.href = `#${h.id}`;
        a.textContent = text;
        li.append(a);
        toc.append(li);
      });
      toc.closest('[data-av-toc-wrap]').hidden = false;
    }
  }

  const add = pdp.querySelector('[data-av-add]');
  const bar = pdp.querySelector('[data-av-mobibar]');
  if (add && bar && 'IntersectionObserver' in window) {
    new IntersectionObserver(([entry]) => {
      const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      bar.classList.toggle('is-on', show);
      bar.setAttribute('aria-hidden', String(!show));
      const btn = bar.querySelector('button');
      if (btn) btn.tabIndex = show ? 0 : -1;
    }).observe(add);
  }
})();
